// extracted by mini-css-extract-plugin
export default {"block":"classes_block__VIFfG","headerWrapper":"classes_headerWrapper__STSDI","header":"classes_header__V8sR-","requirements":"classes_requirements__WpCs2"};